import { render, staticRenderFns } from "./SSNewsView.vue?vue&type=template&id=2f9b656e&scoped=true&"
import script from "./SSNewsView.vue?vue&type=script&lang=js&"
export * from "./SSNewsView.vue?vue&type=script&lang=js&"
import style0 from "./SSNewsView.vue?vue&type=style&index=0&id=2f9b656e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9b656e",
  null
  
)

export default component.exports